var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon5DayStreakGreyFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.508,
    height: 16.522
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "streamline-icon-matches-fire@140x140",
    stroke: "#575757",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2292",
    d: "M13.495 4.75h-.245l-1.755 2.193a8.9 8.9 0 01.24-6.193 8.933 8.933 0 00-7.394 4.652L2.75 3.851a7 7 0 00-.2 9.583 7.137 7.137 0 004.735 2.3 6.823 6.823 0 004.817-1.5 7 7 0 001.394-9.483z",
    fill: "#575757"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2291",
    d: "M6.816 7.012a3.485 3.485 0 01.353 3.971 1.241 1.241 0 01-1.328-1.058 2.81 2.81 0 00-1.457 2.648 3.177 3.177 0 003.178 3.177 3.221 3.221 0 003.179-3.177 5.282 5.282 0 00-3.925-5.561z",
    fill: "#fff"
  }))));
}
export default SvgIcon5DayStreakGreyFilled;